"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = require("react");

var node_html_parser_1 = require("node-html-parser");

var CMSIconContext_1 = require("./CMSIconContext");

var useAllCMSIcons = function useAllCMSIcons() {
  var iconsQuery = (0, react_1.useContext)(CMSIconContext_1.IconsContext); // for when the hook hasn't run yet

  if (!iconsQuery) iconsQuery = {
    nodes: []
  };
  var nodes = iconsQuery.nodes;
  var icons = (0, react_1.useMemo)(function () {
    var iconNodes = [];
    nodes.forEach(function (node) {
      var _a;

      var svg = (_a = node.data.SVG) === null || _a === void 0 ? void 0 : _a.localFiles[0].childSvg.svgString;
      if (!svg) return;
      iconNodes.push({
        name: node.data.Name,
        svg: (0, node_html_parser_1.parse)(svg),
        text: node.data.Text
      });
    });
    return iconNodes;
  }, [nodes]);
  return icons;
};

exports.default = useAllCMSIcons;